import { Mesh, VertexBuffer, VertexData } from '@babylonjs/core'
import ModelViewer from '../ModelViewer'

const transparentMeshes: Mesh[] = []

let cameraIsMoving = false
let timeout: number

function onBeforeAnimations() {
	if (cameraIsMoving) {
		cameraIsMoving = false
		timeout = setTimeout(() => {
			// mesh.updateFacetData()
			// console.log('Camera stopped, updating facet data', transparentMeshes.length)
			transparentMeshes.forEach(mesh => mesh.updateFacetData())
		}, 100)
	}
}
function onViewMatrixChanged() {
	cameraIsMoving = true
	clearTimeout(timeout)
}

export function UpdateDepthSort(viewer: ModelViewer, enabled = true, once = false) {
	disableDepthSorting(viewer)
	if (!enabled) return
	transparentMeshes.push(...viewer.scene.meshes.filter(x => (x.name == 'FRONT' || x.name.startsWith('INNERRIM')) && (x.material?.name.includes('ACETATE/') || x.material?.name.includes('NOW/C')) && !x.material?.needDepthPrePass) as Mesh[])

	transparentMeshes.forEach(mesh => {
		const geometry = mesh.geometry
		if (geometry && !geometry.isVertexBufferUpdatable(VertexBuffer.PositionKind)) {
			const positions = geometry.getVerticesData(VertexBuffer.PositionKind)
			const normals = geometry.getVerticesData(VertexBuffer.NormalKind)
			const indices = geometry.getIndices()

			geometry.setAllVerticesData(new VertexData(), true) // clear old data

			const vertexData = new VertexData()
			vertexData.positions = positions
			vertexData.normals = normals
			vertexData.indices = indices

			vertexData.applyToMesh(mesh, true)

			mesh.mustDepthSortFacets = true
			mesh.updateFacetData()
		} else {
			mesh.mustDepthSortFacets = true
			mesh.updateFacetData()
		}
	})

	if (!once) {
		viewer.scene.onBeforeAnimationsObservable.add(onBeforeAnimations)
		viewer.scene.activeCamera.onViewMatrixChangedObservable.add(onViewMatrixChanged)
	}
}

function disableDepthSorting(viewer: ModelViewer) {
	transparentMeshes.forEach(mesh => mesh.mustDepthSortFacets = false)
	transparentMeshes.length = 0
	viewer.scene.onBeforeAnimationsObservable.removeCallback(onBeforeAnimations)
	viewer.scene.activeCamera.onViewMatrixChangedObservable.removeCallback(onViewMatrixChanged)
}
